import {
  SupplierSignupInvitationQueryQueryCgResponse,
  SupplierSignupInvitationQueryQueryVariables,
} from '@common/graphql';
import { gql, TypedDocumentNode } from '@common/hooks';

export const SUPPLIER_SIGNUP_INVITATION_QUERY: TypedDocumentNode<
  SupplierSignupInvitationQueryQueryCgResponse,
  SupplierSignupInvitationQueryQueryVariables
> = gql`
  query SupplierSignupInvitationQuery($token: String!) {
    supplierSignupInvitation(token: $token) {
      id
      email
      expiresAt
      sentAt
      supplier {
        id
        name
      }
    }
  }
`;
